import { Component, input, InputSignal } from '@angular/core';

@Component({
  selector: 'app-thirteen-minutes',
  standalone: true,
  imports: [],
  templateUrl: './thirteen-minutes.html',
  styleUrls: ['./thirteen-minutes.scss'],
})
export class ThirteenMinutes {
  public status: InputSignal<'past' | 'present' | 'future'> = input.required<'past' | 'present' | 'future'>();
}
